import React, { PropTypes } from 'react';
import _ from 'lodash';
import { replaceUnicode } from 'utils/emojify';

class TextMultiselect extends React.Component {

    constructor(props) {
        super(props);
        var self = this;

        self.state = {
            values: self.props.defaultValues || []
        };
    }

    invokeChangeHandler = () => {
        var self = this;

        if (self.props.onChange != null && typeof self.props.onChange === 'function') {
            self.props.onChange(self.state.values);
        }
    }

    removeValue = (value) => {
        var self = this;

        self.setState({
            values: _.filter(self.state.values, v => v !== value)
        }, () => {
            self.invokeChangeHandler();
        });
    }

    onKeyPress = (e) => {
        var self = this;

        if (e.key !== 'Enter') {
            return;
        }

        // Prevent trigger of form submit
        e.preventDefault();

        self.onChanged();
    }

    onChanged = () => {
        var self = this,
            value = replaceUnicode(self.refs.inputField.value),
            values;

        if (value != null &&
            typeof value === 'string' &&
            value.trim().length > 0 &&
            (self.state.values == null || self.state.values.indexOf(value) === -1)) {

            values = [...self.state.values, value];

            self.setState({
                values
            }, () => {
                self.invokeChangeHandler();
            });
        }

        self.refs.inputField.value = '';
    }

    render () {
        var self = this;

        return (
            <div className="form-control multiselect-container">
                <ul className="multiselect-item-container">
                    { self.state.values.map(value => {
                        return (
                            <li key={ value } className="multiselect-item tag tag-primary">
                                { value }
                                <a href="javascript:void(0)" className="multiselect-item-remove" onClick={ () => self.removeValue(value) }>
                                    <i className="fa fa-remove multiselect-item-remove"></i>
                                </a>
                            </li>
                        );
                    })}
                    <li className="multiselect-input-container">
                        <input type="text" ref="inputField" className="multiselect-input" onKeyPress={ self.onKeyPress } onBlur={ self.onChanged } placeholder={ self.props.placeholder } />
                    </li>
                </ul>
            </div>
        );
    }
};

export default TextMultiselect;


// WEBPACK FOOTER //
// ./src/app/components/multiselect/text.jsx